import React, { useState, useEffect } from "react";

import { useNavigate, Link, useLocation, useOutletContext } from "react-router-dom";
import { UiSelect, UiDatePicker, UiRSelect, TableZero, BgLoader, UiButton } from "../../ui.js";
import Accordion from 'react-bootstrap/Accordion';
import Form from 'react-bootstrap/Form';
import { toast } from "react-toastify";
import { instance } from "../../axios";
import { IoMdHome } from "react-icons/io";

export default function Category() {
  const { setTitle } = useOutletContext();
  const [state, setState] = useState({});
    const [filteredItems, setFilteredItems] = useState([]);
  const [filterText, setFilterText] = React.useState('');


  const navigate = useNavigate();
  const location = useLocation();
  const fetchData = (segments) => {
    instance
      .get("/main_screen.php?category=" + segments.join("/"))
      .then(function (response) {
        setState({ ...state, ...response.data });
        setFilterText("");
        setFilteredItems(response.data.items);
        setTitle(response.data.title)
        if (response.data.status == 'success') {

        } else {
          toast(response.data.msg, { type: "error" });
        }

      })
      .catch(function (error) { })
      .then(function () { });

  }


  // get path segments
  const segments = location.pathname
    .replace("/category/", "")
    .split("/")
    .filter(Boolean);


 useEffect(() => {
    if (state.items) {
      const filteredItems1 = state.items.filter(
        item => item.label && item.label.toLowerCase().includes(filterText.toLowerCase()),
      );
      setFilteredItems(filteredItems1)
    }
  }, [filterText]);


  useEffect(() => {
    fetchData(segments);


  }, [location]);
  return (
    <>
      <div className="mt-3">
        <Form.Group className="mb-3" >
          <Form.Control type="text" name="name1" placeholder="Search" value={filterText} onChange={e => setFilterText(e.target.value)}  />
          
        </Form.Group>
      </div>
      <div className="mt-3 mb-3 d-none">
        <Link to="/" style={{ verticalAlign: 'text-bottom' }}><IoMdHome /></Link>
        {segments.map((segment, index) => {

          const isLast = index === segments.length - 1;
          const path = "/category/" + segments.slice(0, index + 1).join("/");

          return (
            <span key={index}>
              {" / "}
              {isLast ? (
                <strong>{segment}</strong>
              ) : (
                <Link to={path} style={{ textDecoration: 'none' }}>{segment}</Link>
              )}
            </span>
          );
        })}
      </div>
      <div className="mb-3 mt-3">

        {state.col == 2 ?
          <div className="row">
            {filteredItems && filteredItems.map((item, index) => {
              return <div className="col-6" key={index} >
                <div className="rounded border shadow mb-3" onClick={() => { navigate(item.link); }} style={{ cursor: 'pointer' }}>
                  <div className="imgwrap"><img src={item.image} className="rounded-top" /></div>
                  <p className="mb-0 text-center py-2">{item.label}</p>
                </div></div>
            })}
          </div>
          :
          <>
            {filteredItems && filteredItems.map((item, index) => {
              return <button
                key={item.label}
                className="btn btn-outline-dark w-100 mb-2"
                onClick={() => { navigate(item.link); }}
              >
                {item.label}
              </button>
            })}
          </>
        }
      </div>
    </>
  );
}
